export const COUNTRY_SAMPLES = {
  // Africa
  TD: { name: 'Chad', fullName: 'Moussa Mahamat', username: 'moussa_mahamat', phone: '+235 99 12 34 56', professions: 'Ingénieur, Médecin, Étudiant...' },
  SN: { name: 'Senegal', fullName: 'Amadou Diop', username: 'amadou_diop', phone: '+221 77 123 45 67', professions: 'Ingénieur, Médecin, Étudiant...' },
  CI: { name: "Côte d'Ivoire", fullName: 'Kouamé Yao', username: 'kouame_yao', phone: '+225 07 12 34 56 78', professions: 'Ingénieur, Médecin, Étudiant...' },
  CM: { name: 'Cameroon', fullName: 'Jean-Pierre Essomba', username: 'jean_essomba', phone: '+237 6 12 34 56 78', professions: 'Ingénieur, Médecin, Étudiant...' },
  CD: { name: 'DR Congo', fullName: 'Patrick Mbuyi', username: 'patrick_mbuyi', phone: '+243 81 234 5678', professions: 'Ingénieur, Médecin, Étudiant...' },
  MA: { name: 'Morocco', fullName: 'Youssef El Amrani', username: 'youssef_amrani', phone: '+212 6 12 34 56 78', professions: 'Ingénieur, Médecin, Étudiant...' },
  DZ: { name: 'Algeria', fullName: 'Karim Boudiaf', username: 'karim_boudiaf', phone: '+213 5 12 34 56 78', professions: 'Ingénieur, Médecin, Étudiant...' },
  TN: { name: 'Tunisia', fullName: 'Mohamed Ben Ali', username: 'mohamed_benali', phone: '+216 20 123 456', professions: 'Ingénieur, Médecin, Étudiant...' },
  EG: { name: 'Egypt', fullName: 'Ahmed Hassan', username: 'ahmed_hassan', phone: '+20 10 1234 5678', professions: 'مهندس، طبيب، طالب...' },
  NG: { name: 'Nigeria', fullName: 'Chinedu Okonkwo', username: 'chinedu_okonkwo', phone: '+234 803 123 4567', professions: 'Engineer, Doctor, Student...' },
  ZA: { name: 'South Africa', fullName: 'Sipho Mabena', username: 'sipho_mabena', phone: '+27 71 234 5678', professions: 'Engineer, Doctor, Student...' },

  // Europe
  FR: { name: 'France', fullName: 'Jean Dupont', username: 'jean_dupont', phone: '+33 6 12 34 56 78', professions: 'Ingénieur, Médecin, Étudiant...' },
  BE: { name: 'Belgium', fullName: 'Luc Dubois', username: 'luc_dubois', phone: '+32 470 12 34 56', professions: 'Ingénieur, Médecin, Étudiant...' },
  CH: { name: 'Switzerland', fullName: 'Nicolas Müller', username: 'nicolas_muller', phone: '+41 79 123 45 67', professions: 'Ingénieur, Médecin, Étudiant...' },
  DE: { name: 'Germany', fullName: 'Max Mustermann', username: 'max_mustermann', phone: '+49 170 1234567', professions: 'Ingenieur, Arzt, Student...' },
  ES: { name: 'Spain', fullName: 'Juan Pérez', username: 'juan_perez', phone: '+34 612 345 678', professions: 'Ingeniero, Médico, Estudiante...' },
  IT: { name: 'Italy', fullName: 'Mario Rossi', username: 'mario_rossi', phone: '+39 333 123 4567', professions: 'Ingegnere, Medico, Studente...' },
  GB: { name: 'United Kingdom', fullName: 'James Smith', username: 'james_smith', phone: '+44 7700 123456', professions: 'Engineer, Doctor, Student...' },
  PT: { name: 'Portugal', fullName: 'João Silva', username: 'joao_silva', phone: '+351 912 345 678', professions: 'Engenheiro, Médico, Estudante...' },
  NL: { name: 'Netherlands', fullName: 'Pieter Jansen', username: 'pieter_jansen', phone: '+31 6 12345678', professions: 'Engineer, Doctor, Student...' },

  // Americas
  US: { name: 'United States', fullName: 'John Doe', username: 'john_doe', phone: '+1 234 567 8900', professions: 'Engineer, Doctor, Student...' },
  CA: { name: 'Canada', fullName: 'Emma Tremblay', username: 'emma_tremblay', phone: '+1 416 234 5678', professions: 'Engineer, Doctor, Student...' },
  BR: { name: 'Brazil', fullName: 'João Souza', username: 'joao_souza', phone: '+55 11 91234-5678', professions: 'Engenheiro, Médico, Estudante...' },
  MX: { name: 'Mexico', fullName: 'Carlos Hernández', username: 'carlos_hernandez', phone: '+52 55 1234 5678', professions: 'Ingeniero, Médico, Estudiante...' },
  AR: { name: 'Argentina', fullName: 'Martín González', username: 'martin_gonzalez', phone: '+54 9 11 1234-5678', professions: 'Ingeniero, Médico, Estudiante...' },

  // Asia / Middle East
  CN: { name: 'China', fullName: '张三', username: 'zhang_san', phone: '+86 138 1234 5678', professions: '工程师、医生、学生...' },
  JP: { name: 'Japan', fullName: '田中 太郎', username: 'tanaka_taro', phone: '+81 90 1234 5678', professions: 'エンジニア、医師、学生...' },
  KR: { name: 'South Korea', fullName: '김민수', username: 'kim_minsu', phone: '+82 10 1234 5678', professions: '엔지니어, 의사, 학생...' },
  IN: { name: 'India', fullName: 'Rahul Sharma', username: 'rahul_sharma', phone: '+91 98765 43210', professions: 'Engineer, Doctor, Student...' },
  AE: { name: 'UAE', fullName: 'Mohammed Al Ali', username: 'mohammed_alali', phone: '+971 50 123 4567', professions: 'مهندس، طبيب، طالب...' },
  SA: { name: 'Saudi Arabia', fullName: 'Abdullah Al-Rashid', username: 'abdullah_alrashid', phone: '+966 50 123 4567', professions: 'مهندس، طبيب، طالب...' },

  // Default fallback
  DEFAULT: { name: 'World', fullName: 'John Doe', username: 'john_doe', phone: '+1 234 567 8900', professions: 'Engineer, Doctor, Student...' },
};

export const TIMEZONE_TO_COUNTRY = {
  'Africa/Ndjamena': 'TD',
  'Africa/Dakar': 'SN',
  'Africa/Abidjan': 'CI',
  'Africa/Douala': 'CM',
  'Africa/Kinshasa': 'CD',
  'Africa/Casablanca': 'MA',
  'Africa/Algiers': 'DZ',
  'Africa/Tunis': 'TN',
  'Africa/Cairo': 'EG',
  'Africa/Lagos': 'NG',
  'Africa/Johannesburg': 'ZA',
  'Europe/Paris': 'FR',
  'Europe/Brussels': 'BE',
  'Europe/Zurich': 'CH',
  'Europe/Berlin': 'DE',
  'Europe/Madrid': 'ES',
  'Europe/Rome': 'IT',
  'Europe/London': 'GB',
  'Europe/Lisbon': 'PT',
  'Europe/Amsterdam': 'NL',
  'America/New_York': 'US',
  'America/Chicago': 'US',
  'America/Denver': 'US',
  'America/Los_Angeles': 'US',
  'America/Toronto': 'CA',
  'America/Sao_Paulo': 'BR',
  'America/Mexico_City': 'MX',
  'America/Argentina/Buenos_Aires': 'AR',
  'Asia/Shanghai': 'CN',
  'Asia/Beijing': 'CN',
  'Asia/Tokyo': 'JP',
  'Asia/Seoul': 'KR',
  'Asia/Kolkata': 'IN',
  'Asia/Dubai': 'AE',
  'Asia/Riyadh': 'SA',
};

export function getCountryData(countryCode) {
  return COUNTRY_SAMPLES[countryCode?.toUpperCase()] || COUNTRY_SAMPLES.DEFAULT;
}

export function detectCountry() {
  // Try timezone-based detection first
  try {
    const tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
    if (tz) {
      const zoneCountry = TIMEZONE_TO_COUNTRY[tz];
      if (zoneCountry) return zoneCountry;
    }
  } catch (e) { /* ignore */ }

  // Try navigator.language
  try {
    const lang = navigator.language || navigator.userLanguage || '';
    const langCountry = lang.split('-')[1];
    if (langCountry) return langCountry.toUpperCase();
  } catch (e) { /* ignore */ }

  return null;
}
